import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, [
    _createVNode("path", { d: "M14.054 5.985a.944.944 0 00-.836-.485h-2.402a.96.96 0 00-.865.526c-.566 1.134-1.83 3.877-1.943 5.97a.004.004 0 01-.004.004.004.004 0 00-.004.004V18.5a2 2 0 002 2h4a2 2 0 002-2v-6.497a.003.003 0 00-.003-.003.003.003 0 01-.003-.003c-.1-2.39-1.368-4.965-1.94-6.012z" }),
    _createVNode("rect", {
      width: "6",
      height: "2",
      x: "9",
      y: "3.5",
      rx: ".5"
    }),
    _createVNode("path", {
      "stroke-linecap": "round",
      d: "M10 12.5V18"
    })
  ]))
}